import { EntityAttachmentsButton } from '@Components/Attachments/EntityAttachmentsButton';
import { PrintOptionsMenu } from '@Modules/Documents';
import { Button, defaultIconSize } from '@synqo/frontend-component-library';
import { IconCurrencyEuro } from '@tabler/icons-react';
import { type ReactNode } from 'react';
import { type OrderActions } from './useOrderActions';

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function orderActionItems(actions: OrderActions, i18n: (text: string) => string): ReactNode[] {
    return [
        actions.canApprove && (
            <Button key="approve" appearance="filled" onClick={actions.approveOrder} variant="secondary">
                Freigabe für Faktura
            </Button>
        ),
        actions.isCollectible && (
            <Button
                key="cash_payment"
                appearance="filled"
                onClick={actions.cashPaymentModal.open}
                locked={!actions.canCollect}
                tooltip={actions.collectionTooltip}
                variant="secondary"
            >
                <IconCurrencyEuro size={defaultIconSize} />
                &nbsp;{i18n(actions.collectionActionText)}
            </Button>
        ),
    ];
}

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function orderMenuItems(actions: OrderActions, isEditing: boolean): ReactNode[] {
    return [
        actions.canPrint && <PrintOptionsMenu key="print_menu" {...actions.printOptionsInfo} disabled={isEditing} />,
        actions.canReadAttachments && (
            <EntityAttachmentsButton
                key="attachments"
                attachmentsInfo={actions.attachmentsInfo}
                canUpload={actions.canManageAttachments}
                canDownload={actions.canDownloadAttachments}
                canDelete={actions.canManageAttachments}
            />
        ),
    ];
}
